if (!customElements.get('component-footer')) {
  class ComponentFooter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.details = this.querySelectorAll('details');

      if (!this.details.length) return;

      this.breakpoint = window.matchMedia('(min-width: 990px)');
      this.onBreakpointChange = () => this.sync();

      this.breakpoint.addEventListener('change', this.onBreakpointChange);
      this.sync();
    }

    disconnectedCallback() {
      if (this.breakpoint && this.onBreakpointChange) {
        this.breakpoint.removeEventListener('change', this.onBreakpointChange);
      }
    }

    sync() {
      this.details.forEach((details) => {
        details.open = this.breakpoint.matches;
      });
    }
  }

  customElements.define('component-footer', ComponentFooter);
}
